import * as React from 'react';
import type { FieldValues } from 'react-hook-form';
import { useController, type UseControllerProps } from 'react-hook-form';

import Checkbox from 'af-components/Controls/Checkbox';

type Props<T extends FieldValues> = UseControllerProps<T> & {
	label?: string | React.JSX.Element;
	onChange?: (name: string) => void;
};

function RHFCheckbox<T extends FieldValues>(props: Props<T>) {
	const { name, onChange, label, control, defaultValue } = props;

	const {
		field,
	} = useController({
		name,
		control,
		defaultValue,
	});

	const handleChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		field.onChange(event.target.checked);
		onChange?.(name);
	}, [field, name, onChange]);

	return (
		<Checkbox
			handleChange={handleChange}
			isChecked={!!field.value}
			label={label}
		/>
	);
}

export default React.memo(RHFCheckbox) as typeof RHFCheckbox;
